export function determinePlanningSummary(actionItem) {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Remove time for accurate comparison

  if (actionItem.status === 'Completed') return 'Completed';
  if (actionItem.status === 'Cancelled') return 'Cancelled';
  if (new Date(actionItem.dueDate) < today) return 'Overdue';
  return 'On Track';
}

export function determineInitiativePlanningSummary(initiative) {
  if (initiative.weeklyStatus === 'Cancelled') {
    return 'Cancelled';
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const fiveDaysLater = new Date(today);
  fiveDaysLater.setDate(today.getDate() + 5);

  const stages = ['L0', 'L1', 'L2', 'L3', 'L4', 'L5'];
  const stageData = {};

  for (const stage of stages) {
    const entry = initiative.timeline.find((entry) => entry.stage === stage);
    stageData[stage] = {
      plan: entry?.date?.plan ? new Date(entry.date.plan) : null,
      actual: entry?.date?.actual ? new Date(entry.date.actual) : null,
    };
  }

  const currentStageIndex = stages.indexOf(initiative.stage);
  const planningSummaries = [];

  if (currentStageIndex === -1 || currentStageIndex === stages.length - 1) {
    // If the initiative stage is invalid or the last stage, return the current stage's summary.
    const currentStageData = stageData[initiative.stage];

    if (currentStageData.actual !== null) {
      planningSummaries.push(`Completed ${initiative.stage}`);
    } else if (currentStageData.plan === null) {
      planningSummaries.push(`Not Planned for ${initiative.stage}`);
    } else if (currentStageData.plan < today && currentStageData.actual === null) {
      planningSummaries.push(`Past Due for ${initiative.stage}`);
    } else if (currentStageData.plan <= fiveDaysLater && currentStageData.actual === null) {
      planningSummaries.push(`Due Soon for ${initiative.stage}`);
    } else {
      planningSummaries.push(`On Plan for ${initiative.stage}`);
    }
  } else {
    // Check planning summary for future stages.
    for (let i = currentStageIndex + 1; i < stages.length; i++) {
      const futureStage = stages[i];
      const futureStageData = stageData[futureStage];

      if (futureStageData.actual !== null) {
        planningSummaries.push(`Completed ${futureStage}`);
      } else if (futureStageData.plan === null) {
        planningSummaries.push(`Not Planned for ${futureStage}`);
      } else if (futureStageData.plan < today) {
        planningSummaries.push(`Past Due for ${futureStage}`);
      } else if (futureStageData.plan <= fiveDaysLater) {
        planningSummaries.push(`Due Soon for ${futureStage}`);
      } else {
        planningSummaries.push(`On Plan for ${futureStage}`);
      }
    }
  }

  return planningSummaries.join(', '); // Return all summaries joined by a comma
}
